import { queryClient } from '@/Root';
import { useMutation, useQuery } from 'react-query';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { getErrorMessageGP } from './getErrorMessageGP';
import statusServices from './status.services';
import { GPStatusListRequest } from './status.types';

export const GP_STATUS_LIST_KEY = 'status/list';
export const GP_STATUS_DETAIL_KEY = 'status/detail';
export const GP_STATUS_CREAT_KEY = 'status/create';
export const GP_STATUS_EDIT_KEY = 'status/edit';
export const GP_STATUS_DELETE_KEY = 'status/delete';
export const GP_STATUS_CHANGE_POSITION_KEY = 'status/change-position';

export function useGPStatusList(enabled = true, params?: GPStatusListRequest) {
  const cache = queryClient.getQueryData([GP_STATUS_LIST_KEY, { ...params }]);

  return useQuery({
    queryKey: [GP_STATUS_LIST_KEY, { ...params }],
    queryFn: () => statusServices.list({ ...params }),
    enabled: enabled && !cache,
  });
}

export function useGPStatusDetail(statusId?: string) {
  const cache = queryClient.getQueryData([GP_STATUS_DETAIL_KEY, { statusId }]);

  return useQuery({
    queryKey: [GP_STATUS_DETAIL_KEY, { statusId }],
    queryFn: () => statusServices.detail(statusId),
    enabled: !!statusId && !cache,
  });
}

export function useGPStatusCreate() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationKey: [GP_STATUS_CREAT_KEY],
    mutationFn: statusServices.create,
    onSuccess() {
      notification.success({
        message: 'Status cadastrado com sucesso',
      });

      queryChanel({ resetQueries: [[GP_STATUS_LIST_KEY]] });
    },
    onError(err: Error) {
      notificationError({
        message: getErrorMessageGP(err),
      });
    },
  });
}

export function useGPStatusEdit() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationKey: [GP_STATUS_EDIT_KEY],
    mutationFn: statusServices.edit,
    onSuccess(_, vars) {
      notification.success({
        message: 'Status atualizado com sucesso',
      });

      queryChanel({
        resetQueries: [
          [GP_STATUS_LIST_KEY],
          [GP_STATUS_DETAIL_KEY, { statusId: vars.id }],
        ],
      });
    },
    onError(err: Error) {
      notification.success({
        message: getErrorMessageGP(err),
      });
    },
  });
}

export function useGPStatusDelete() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationKey: [GP_STATUS_DELETE_KEY],
    mutationFn: statusServices.delete,
    onSuccess() {
      notification.success({
        message: 'Status removido com sucesso',
      });

      queryChanel({ resetQueries: [[GP_STATUS_LIST_KEY]] });
    },
    onError(err: Error) {
      notification.success({
        message: getErrorMessageGP(err),
      });
    },
  });
}

export function useGPStatusPosition() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationKey: [GP_STATUS_CHANGE_POSITION_KEY],
    mutationFn: statusServices.position,
    onSuccess() {
      queryChanel({ invalidateQueries: [[GP_STATUS_LIST_KEY]] });
    },
    onError(err: Error) {
      notification.success({
        message: getErrorMessageGP(err),
      });
    },
  });
}
